<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      searchData: debounce(() => {
        this.getUserReports();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "report_reason",
          sortable: true,
          label: "Reason",
        },
        {
          key: "description",
          sortable: true,
          label: "Description",
        },
        {
          key: "created_at",
          sortable: true,
          label: "Created At",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {
    makeData: {
      name: { required },
    },
  },
  computed: {
    ...mapGetters("userReport", [
      "getAllUserReport",
      "loading",
      "userReportCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getUserReports();
  },
  methods: {
    ...mapActions("userReport", ["getUserReport"]),
    getUserReports(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getUserReport(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUserReports();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    User Reports ({{ userReportCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllUserReport"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(created_at)="items">
                    {{
                      moment
                        .duration(moment(new Date(items.item.created_at)).diff(moment()))
                        .humanize(true)
                    }}
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllUserReport.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No User Report Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUserReports"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.multiselect {
  width: 250px !important;
}
</style>
